import { parseAbi } from 'viem';

export const poolAbi = parseAbi([
  'function getUserAccountData(address user) view returns (uint256 totalCollateralBase, uint256 totalDebtBase, uint256 availableBorrowsBase, uint256 currentLiquidationThreshold, uint256 ltv, uint256 healthFactor)',
  'function getVirtualUnderlyingBalance(address asset) view returns (uint128)',
  'function supply(address asset, uint256 amount, address onBehalfOf, uint16 referralCode)',
  'function withdraw(address asset, uint256 amount, address to) returns (uint256)',
  'function borrow(address asset, uint256 amount, uint256 interestRateMode, uint16 referralCode, address onBehalfOf)',
  'function repay(address asset, uint256 amount, uint256 interestRateMode, address onBehalfOf) returns (uint256)',
  'function setUserUseReserveAsCollateral(address asset, bool useAsCollateral)',
]);

export const dataProviderAbi = parseAbi([
  'function getReserveConfigurationData(address asset) view returns (uint256 decimals, uint256 ltv, uint256 liquidationThreshold, uint256 liquidationBonus, uint256 reserveFactor, bool usageAsCollateralEnabled, bool borrowingEnabled, bool stableBorrowRateEnabled, bool isActive, bool isFrozen)',
  'function getReserveData(address asset) view returns (uint256 unbacked, uint256 accruedToTreasuryScaled, uint256 totalAToken, uint256 totalStableDebt, uint256 totalVariableDebt, uint256 liquidityRate, uint256 variableBorrowRate, uint256 stableBorrowRate, uint256 averageStableBorrowRate, uint256 liquidityIndex, uint256 variableBorrowIndex, uint40 lastUpdateTimestamp)',
  'function getReserveCaps(address asset) view returns (uint256 borrowCap, uint256 supplyCap)',
  'function getPaused(address asset) view returns (bool)',
  'function getReserveTokensAddresses(address asset) view returns (address aTokenAddress, address stableDebtTokenAddress, address variableDebtTokenAddress)',
  'function getUserReserveData(address asset, address user) view returns (uint256 currentATokenBalance, uint256 currentStableDebt, uint256 currentVariableDebt, uint256 principalStableDebt, uint256 scaledVariableDebt, uint256 stableBorrowRate, uint256 liquidityRate, uint40 stableRateLastUpdated, bool usageAsCollateralEnabled)',
]);

export const oracleAbi = parseAbi(['function getAssetPrice(address asset) view returns (uint256)']);

export const rateStrategyAbi = parseAbi([
  'struct InterestRateData { uint16 optimalUsageRatio; uint32 baseVariableBorrowRate; uint32 variableRateSlope1; uint32 variableRateSlope2; }',
  'function getInterestRateDataBps(address reserve) view returns (InterestRateData)',
]);

export const adapterAbi = parseAbi([
  'function status() view returns (uint256 price, uint256 updatedAt, uint256 age, bool oraclePaused, uint256 uiMultiplier, uint256 pendingMultiplier, uint256 pendingEffectiveAt)',
]);

export const feedAbi = parseAbi([
  'function latestRoundData() view returns (uint80 roundId, int256 answer, uint256 startedAt, uint256 updatedAt, uint80 answeredInRound)',
  'function getRoundData(uint80 roundId) view returns (uint80 roundId_, int256 answer, uint256 startedAt, uint256 updatedAt, uint80 answeredInRound)',
  'function decimals() view returns (uint8)',
  'function description() view returns (string)',
  'function owner() view returns (address)',
  'function latestRound() view returns (uint256)',
  'function latestStored() view returns (uint80 roundId, int256 answer, uint64 updatedAt)',
  'function overrideActive() view returns (bool)',
]);

/** ERC-8056 / Robinhood stock token surface used by the keeper and the app (mainnet and testnet tokens alike). */
export const stockTokenAbi = parseAbi([
  'function uiMultiplier() view returns (uint256)',
  'function newUIMultiplier() view returns (uint256)',
  'function effectiveAt() view returns (uint256)',
  'function balanceOfUI(address account) view returns (uint256)',
  'function oraclePaused() view returns (bool)',
  'function paused() view returns (bool)',
  'function updateMultiplier(uint256 newMultiplier)',
  'function updateMultiplier(uint256 newMultiplier, uint256 effectiveAt)',
  'function pauseOracle()',
  'function unpauseOracle()',
]);

export const faucetAbi = parseAbi([
  'function claim(address token)',
  'function claimMany(address[] tokens)',
  'function nextClaimAt(address token, address account) view returns (uint256)',
  'function drips(address token) view returns (uint128 amount, uint32 cooldown, bool enabled)',
]);

export const routerAbi = parseAbi([
  'struct RoundInput { uint80 roundId; int256 answer; uint64 startedAt; uint64 updatedAt; }',
  'function push(address[] feeds, RoundInput[][] rounds)',
  'function setOverride(address feed, int256 answer)',
  'function clearOverride(address feed)',
  'function keeper() view returns (address)',
  'function keeperPaused() view returns (bool)',
  'function maxStepBps() view returns (uint16)',
  'function owner() view returns (address)',
]);

export const erc20Abi = parseAbi([
  'function balanceOf(address account) view returns (uint256)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function mint(uint256 value) returns (bool)',
]);

export const multicall3Abi = parseAbi([
  'function getEthBalance(address addr) view returns (uint256 balance)',
  'function getBlockNumber() view returns (uint256 blockNumber)',
  'function getCurrentBlockTimestamp() view returns (uint256 timestamp)',
]);
